import { omit } from 'lodash';

import { JournalingEventListResponse } from 'generated/bffJournaling/models';
import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import dayjs from 'helpers/dayjs';

import { ChannelType } from 'models/ChannelType';
import { JournalingEntityType, JournalingFilterParams } from 'models/Journaling';
import { Pagination } from 'models/Pagination';
import { CustomerMasterSourceType } from 'models/swagger/customerMasterSourceType';

export const api = {
  getEventList: (
    url: string,
    entityType: JournalingEntityType,
    entityRefNo: string,
    filter: JournalingFilterParams,
    pagination: Pagination
  ): Promise<ExtendedAxiosResponse<JournalingEventListResponse>> => {
    filter.eventDateFrom = filter.eventDateFrom ? dayjs(filter.eventDateFrom).startOf('day').format() : undefined;
    filter.eventDateTo = filter.eventDateTo ? dayjs(filter.eventDateTo).endOf('day').format() : undefined;

    return apiClient.get(`${url}/journaling/events`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        entityType,
        entityRefNo,
        ...omit(filter, ['originatorType']),
        eventDateFrom: filter.eventDateFrom,
        eventDateTo: filter.eventDateTo,
        ...omit(pagination, ['initPages']),
      },
    });
  },

  getCategoryFilters: (
    url: string,
    entityType: JournalingEntityType,
    entityRefNo: string
  ): Promise<ExtendedAxiosResponse<JournalingEventListResponse>> =>
    apiClient.get(`${url}/journaling/events/filters`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        entityType,
        entityRefNo,
      },
    }),

  getEventDetail: (
    url: string,
    entityType: JournalingEntityType,
    entityRefNo: string,
    eventId: number
  ): Promise<ExtendedAxiosResponse<JournalingEventListResponse>> =>
    apiClient.get(`${url}/journaling/events`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        entityType,
        entityRefNo,
        eventId,
      },
    }),
};
